import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import Flyout from './Components/Flyout';
import FlyoutLoading from './Components/FlyoutLoading';
import Alert from './Components/Alert';

const FlyoutView = ({
  loading,
  updating,
  error,
  visible,
  handleClose,
  stackIndex,
  stackId,
  totalFlyoutCount,
  pushedByCount,
  handleCreateInnerView,
}) => {
  const errorMessage = error ? error.message : null;
  const errorDetails = error ? error.detail : null;
  const errorSubtitle = errorDetails ? 'Error Details:' : null;
  const hasError = !_.isNil(error);
  const isLoading = loading || updating;
  const flyoutClasses = `flyout-${stackId} flyout-${stackIndex} flyout-${stackIndex + 1}-of-${totalFlyoutCount} flyout-pushed-by-${pushedByCount}`;
  // We want to be able to re-display the alert if it changes but has the
  // same inner message. This token should change per instanceId and
  // cause a hide / show. See helpers.normalizeError
  const alertReshowToken = error ? error.instanceId : null;

  let loadingMessage = null;
  if (loading) {
    loadingMessage = 'Loading';
  } else if (updating) {
    loadingMessage = 'Updating';
  }

  return (
    <Flyout handleClose={handleClose} isOpen={visible} classes={flyoutClasses}>
      <div className='detail'>
        <FlyoutLoading show={isLoading} loadingMessage={loadingMessage} minimumShowtimeMs={300} />
        {hasError && <Alert color='danger' reshowToken={alertReshowToken} details={errorDetails} message={errorMessage} subtitle={errorSubtitle} />}
        {!isLoading && handleCreateInnerView()}
        <div className='footer-gradient' />
      </div>
    </Flyout>);
};

FlyoutView.propTypes = {
  loading: PropTypes.bool,
  updating: PropTypes.bool,
  error: PropTypes.shape({}),
  // These are needed in inner view factory from Container
  data: PropTypes.shape({}), // eslint-disable-line react/no-unused-prop-types
  dataType: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
  parentStackId: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
  visible: PropTypes.bool,
  stackIndex: PropTypes.number.isRequired,
  stackId: PropTypes.string.isRequired,
  totalFlyoutCount: PropTypes.number.isRequired,
  pushedByCount: PropTypes.number.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleCreateInnerView: PropTypes.func.isRequired,
};

FlyoutView.defaultProps = {
  loading: false,
  updating: false,
  error: null,
  visible: false,
  data: {},
  parentStackId: null,
};

export default FlyoutView;



// WEBPACK FOOTER //
// ./src/views/FlyoutView.js